import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormHelperText from '@mui/material/FormHelperText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CircularProgress from '@mui/material/CircularProgress';
import Avatar from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';
import { Icon } from '@iconify/react';
import { getToken, storeAdmin } from '../../../services/LocalStorageService';
import {  useUpdatePropertyMutation, 
          useDeleteProprtyMutation,
          useUserViewQuery,
          useUserAccessMutation,
          useUpdateUserAccessMutation,
          useNetworksListQuery,
          useSyncAppMutation,
          useNetworksMutation,
          useGetUserAccessQuery
        } from '../../../services/dvagent';
import { Toaster } from '../attributes';
import Iconify from '../../../components/iconify';
import serverUrl from '../../../_mock/account'

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: 'long',
    day: '2-digit',
    year: 'numeric'
  });
  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return `${formattedDate} ${formattedTime} `;
}

export default function Update(property) {
  const pagelocation = useLocation();
  const [propertyName, setPropertyName] = React.useState(property.property.name);
  const [location, setLocation] = React.useState(property.property.location);
  const [alexa, setAlexa] = useState(property.property.is_alexa);
  const [active, setActive] = useState(property.property.is_active);
  const [apikey, setAPikey] = React.useState(property.property.api_key);
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(serverUrl.serverUrl+property.property.thumbnail);
  const [apikeyCopy, setAPikeyCopy] = React.useState(apikey);
  const [networkList, setNetworkList] = React.useState([]);
  const [selectedNetwork, setSelectedNetwork] = React.useState("");
  const [selectedNetworkList, setSelectedNetworkList] = React.useState(property.property.network);
  const [havePropertyManageAccess, setHavePropertyManageAccess] = useState(false);
  const [haveSyncApplicationAccess, setHaveSyncApplicationAccess] = useState(false);
  const [updateProperty] = useUpdatePropertyMutation();
  const [deleteProperty] = useDeleteProprtyMutation();
  const [userAccessMutation] = useUserAccessMutation();
  const [syncAppMutation] = useSyncAppMutation();
  const [updateUserAccessMutation] = useUpdateUserAccessMutation();
  const [networks] = useNetworksMutation();
  // const { data:userInfomation, isSuccess:userIsSuccess, error:userError } = useUserViewQuery({"token":getToken(), "location":pagelocation});
  const { data:networkListData, isSuccess:networkIsSuccess, error:networkError } = useNetworksListQuery({"apiKey":property.property.api_key, "organisationId":property.property.organisation_id,"token":getToken(), "location":pagelocation});
  const { data:userAccessData, isSuccess:userAccessIsSuccess, error:userAccessError } = useGetUserAccessQuery({"token":getToken(), "id":property.property.id, "location":location});
  const [appLogo, setAppLogo] = useState('../../assets/app/logocopy.png');
  const [open, setOpen] = useState(false);
  const [propertyNameError, setPropertyNameError] = React.useState("");
  const [locationError, setLocationError] = React.useState("");
  const [popupTitle, setPopupTitle] = useState('');
  const [popupLogo, setPopupLogo] = useState('');
  const [syncLoading, setSyncLoading] = useState();
  const [buttonDisabled, setButtonDisabled] = useState([]);
  const [popupWidth, setPopupWidth] = useState(0);
  const [askPopup, setAskPopup] = useState(false);
  const [askDeletePopup, setAskDeletePopup] = useState(false);
  const [addUserPopup, setAddUserPopup] = useState(false);
  const [currentNetwork, setCurrentNetwork] = useState([]);
  const [addUserAccess, setAddUserAccess] = useState("viewer");
  const [addUserEmail, setAddUserEmail] = useState("");
  const [userPermissiom, setUserPermissiom] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addUserEmailError, setAddUserEmailError] = useState("");
  const [userInfo, setUserInfo] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [apiKeyError, setApiKeyError] = useState("");
  const [confirmAction, setConfirmAction] = useState("");
  const [confirmActionError, setConfirmActionError] = useState("");
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });
  const apiKey = property.property.api_key;
  const navigate = useNavigate();

  const sortedUserInfo = userInfo.slice().sort((a, b) => a.email.localeCompare(b.email));

  const handleEditClick = () => {
    setEditMode(!editMode);
  };
  
  const handlePopupAsk = () => {
    if(!havePropertyManageAccess){
      showToast(false, 'ⓘ', 'Access Denied');
      return
    }
    if (!propertyName) {
      setPropertyNameError('Please enter property name.');
    }
    if (!location) {
      setLocationError('Please enter property location.');
    }
    if (!apikey) {
      setApiKeyError('Please enter API key.');
    }
    if (Boolean(apiKeyError)) {
      setApiKeyError('Invalid API key');
    }
    if (!propertyName || !location || !apikey || Boolean(apiKeyError)) {
      return;
    }
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Do you want to change property information")
    setPopupLogo("../../assets/app/ask.gif")
    setPopupWidth(80);
    setAskPopup(true);
    setOpen(true);
  };

  const handleDeletePopupAsk = () => {
    if(!havePropertyManageAccess){
      showToast(false, 'ⓘ', 'Access Denied');
      return
    }
    setConfirmAction('')
    setConfirmActionError('')
    setPopupTitle("Are you sure, you want to remove property")
    setPopupLogo("../../assets/app/ask.gif")
    setPopupWidth(80); 
    setAskPopup(true);
    setAskDeletePopup(true);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAddUserPopup(false);
  };

  const handleUpdate = async () => {
    if(confirmAction !== propertyName){
      setConfirmAction('')
      setConfirmActionError('Property name does not match');
      return
    }
    setOpen(false);
    setAskPopup(false);
    const formData = new FormData();
    formData.append("id", property.property.id);
    formData.append("name", propertyName);
    if (thumbnail) {
      formData.append("thumbnail", thumbnail); 
    }
    formData.append("application_identifier", "null");
    formData.append("api_key", apikeyCopy);
    formData.append("location", location);
    formData.append("is_alexa", alexa);
    formData.append("is_active", active);
    formData.append("network", JSON.stringify(selectedNetworkList));
    
    const res = await updateProperty({token:getToken(), data:formData });

    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Something went wrong, bad request');
      } else if (res.error.status===401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Something went wrong, Unable to change property information');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      showToast(true, '✔', 'Property information changed');
    } 
    if (res.data===null) {
      showToast(true, '✔', 'Property information changed');
    }
    setOpen(false);
    setAskPopup(false);
    setConfirmAction('')
    setConfirmActionError('')
  };

  const handleDelete = async () => {
    if(confirmAction !== propertyName){
      setConfirmAction('')
      setConfirmActionError('Property name does not match');
      return
    }
    setOpen(false);
    setAskPopup(false);
    const actualData = {
      data: {
        "id": property.property.id,
      },
      token: getToken()
    }
    const res = await deleteProperty(actualData);
    if (res.error) {
      if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else if (res.error.status===401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if (res.error.status==="FETCH_ERROR") {
        showToast(false, 'ⓘ', 'Something went wrong, unable to remove property');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    setOpen(false);
    setAskPopup(false);
    if (res.data) {
      showToast(true, '✔', 'Property information removed');
      setTimeout(() => {
        navigate('/cloud/properties');
      }, 3000);
    }
    if (res.data===null) {
      showToast(true, '✔', 'Property information removed');
      setTimeout(() => {
        navigate('/cloud/properties');
      }, 3000);
    }
    setConfirmAction('')
    setConfirmActionError('')
  };

  const handleAppIdentifier = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, appIdentifier: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  };
  
  const handleSyncAppVersion = async (networkId, identifier, tagDv, tagMaintenance, appId, index) => {
    if(!haveSyncApplicationAccess){
      showToast(false, 'ⓘ', 'Access Denied');
      return
    }
    if (!identifier) {
      showToast(false, 'ⓘ', 'Application identifier missing');
      return;
    }
    setButtonDisabled((prevState) => {
      const newState = [...prevState];
      newState[index] = true;
      return newState;
    });
    setSyncLoading(true);

    const formData = new FormData();
    formData.append("id", property.property.id);
    formData.append("network_id", networkId);
    formData.append("appIdentifier", identifier);
    formData.append("tag_dv", tagDv);
    formData.append("tag_maintenance", tagMaintenance);
    formData.append("appId",appId );

    const res = await syncAppMutation({token:getToken(), data:formData });
    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Something went wrong, bad request');
      } else if (res.error.status===401) {
        showToast(false, 'ⓘ', 'Access Denied');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
      setSyncLoading(false);
    } else{
      showToast(true, '✔', 'Application version synced');
      const networkData = selectedNetworkList.map((item, i) => {
        if (i === index) {
          return ({ ...item, version: res.data.data.version, build_version: res.data.data.build_version, icon: res.data.data.icon})
        }
        return item
      })
      setSelectedNetworkList(networkData)
      setSyncLoading(false);
    }
    setButtonDisabled((prevState) => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  const handleAPIKey = (event) => {
    setAPikey(event.target.value);
    setAPikeyCopy(event.target.value);
  };

  const handleLocation = (event) => {
    setLocation(event.target.value);
    setLocationError("");
  };

  const handlePropertyName = (event) => {
    setPropertyName(event.target.value);
    setPropertyNameError("");
  };

  const handleConfirmAction = (event) => {
    setConfirmAction(event.target.value);
    setConfirmActionError("");
  };

  const handleDisplayName = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, displayName: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleApplicationID = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, appId: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleSAMTag = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, tag_dv: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleMaintenanceTag = (event, index) => {
    const networkData = selectedNetworkList.map((item, i) => {
      if (i === index) {
        return ({ ...item, tag_maintenance: event.target.value })
      }
      return item
    })
    setSelectedNetworkList(networkData)
  }

  const handleAddUserPopup = async (item) => {
    setAddUserPopup(true);
    setLoading(true);
    setUserPermissiom([]);
    // if (userError) {
    //   if (userError.status === 401) {
    //     showToast(false, 'ⓘ', 'Unauthorized User');
    //   } else {
    //     showToast(false, 'ⓘ', 'Something went wrong, please try again');
    //   }
    // } 
    // if (userInfomation && userIsSuccess) {
    //   setUserInfo(userInfomation.data)
    // }
    const actualData = {
      name: property.property.name,
      networkId: item.id,
      token: getToken()
    }
    const res = await userAccessMutation(actualData);
    if (res.error) {
      if (res.error) {
        if (res.error.status===500) {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        } else if (res.error.status==="FETCH_ERROR") {
          showToast(false, 'ⓘ', 'Something went wrong, unable to fetch users');
        } else {
          showToast(false, 'ⓘ', 'Something went wrong, please try again');
        }
      }
    }
    if (res.data) {
      setLoading(false);
      setUserPermissiom(res.data.user);
    }
    setCurrentNetwork(item);
    setAddUserEmail("");
  };

  const handleUserAddToNetwork = () => {
    if (!addUserEmail) {
      setAddUserEmailError('Please select an email');
      return;
    }
    const data = {
      "name": property.property.name,
      "network_name": currentNetwork.displayName,
      "network_id": currentNetwork.id,
      "permission": addUserAccess,
      "api_key": apiKey,
      "user_email": addUserEmail,
      "organisation_id": property.property.organisation_id
    }
    setUserPermissiom(prevItems => [...prevItems, data]);
    setAddUserEmail("");
    setAddUserAccess("viewer");
  };

  const handleUpdateUserPermission = (event, index) => {
    const permission = userPermissiom.map((item, i) => {
      if (i === index) {
        return ({ ...item, permission: event.target.value })
      }
      return item
    })
    setUserPermissiom(permission)
  };

  const handleUpdateUserPermissionToNw = async () => {
    const actualData = {
      data: userPermissiom,
      token: getToken()
    }
    const res = await updateUserAccessMutation(actualData);
    if (res.error) {
      if (res.error.status===400) {
        showToast(false, 'ⓘ', 'Something went wrong, bad request');
      } else if (res.error.status===500) {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, please try again');
      }
    }
    if (res.data) {
      setAddUserPopup(false);
    }
  };

  const handleAddToSelectedNetworkList = (id) => {
    if(!havePropertyManageAccess){
      showToast(false, 'ⓘ', 'Access Denied');
      return
    }
    const itemToAdd = networkList.find(item => item.id === id);
    if (itemToAdd) {
      setSelectedNetworkList([...selectedNetworkList, itemToAdd]);
      setNetworkList(networkList.filter(item => item.id !== id));
    }
  };

  const handleAddToNetworkList = (id) => {
    if(!havePropertyManageAccess){
      showToast(false, 'ⓘ', 'Access Denied');
      return
    }
    const itemToAdd = selectedNetworkList.find(item => item.id === id);
    if (itemToAdd) {
      setNetworkList([...networkList, itemToAdd]);
      setSelectedNetworkList(selectedNetworkList.filter(item => item.id !== id));
    }
  };

  const handleNetworks = async (event) => {
    setApiKeyError("");
    if (event.target.value.length >= 40) {
      const actualData = {
        apiKey: event.target.value,
        organisationId: property.property.organisation_id,
        token: getToken()
      }
      const res = await networks(actualData)
      if (res.error) {
        if (res.error.status===500) {
          setApiKeyError("This API Key doesn't have the same access privilege as the previous one. Grant access to the API Key before modifying it.");
        } else if (res.error.status==="FETCH_ERROR") {
          setApiKeyError("Unable to fetch, server error");
        } else {
          setApiKeyError("Wrong API Key");
        }
      }
      if (res.data) {
        if (res.data.data.errors) {
          setApiKeyError("Invalid API key");
        } else {
          const responseList = res.data.data;
          const isAnyNetworkPresent = responseList.some(network => {
            return selectedNetworkList.some(selectedNetwork => selectedNetwork.id === network.id);
          });
          if(isAnyNetworkPresent){
            setApiKeyError("");
          } else {
            setApiKeyError("This API Key doesn't have the same access privilege as the previous one. Grant access to the API Key before modifying it.");
          }
        }
      }      
    } else if (event.target.value.length === 0) {
      setApiKeyError("Please enter API key");
    } else {
      setApiKeyError("Invalid API key");
    }
  }

  const handleCancel = () => {
    navigate('/cloud/properties');
  }

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };

  const handleThumbnailChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnailPreview(reader.result); 
      };
      reader.readAsDataURL(file); 
      setThumbnail(file); 
    }
  };

  useEffect(() => {
    try{
      setHavePropertyManageAccess(userAccessData.data.have_property_manage_access)
      setHaveSyncApplicationAccess(userAccessData.data.have_sync_application_access)
    } catch {
      setHavePropertyManageAccess(false)
      setHaveSyncApplicationAccess(false)
    }
    if (networkListData && networkIsSuccess) {
      const filteredList = networkListData.data.filter(itemOne => {
        return !selectedNetworkList.some(itemTwo => itemTwo.id === itemOne.id);
      });
      const updatedSelectedNetworkList = selectedNetworkList.map(selectedItem => {
        const foundItem = networkListData.data.find(item => item.id === selectedItem.id);
        if (foundItem) {
          return {
            ...selectedItem,
            tags: foundItem.tags
          };
        }
        return selectedItem;
      });
      setNetworkList(filteredList);
      setSelectedNetworkList(updatedSelectedNetworkList);
    }
  }, [networkListData, networkIsSuccess, networkError]);
 
  return (
    <>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {popupTitle}
        </DialogTitle>
        <DialogContent>
          <Box
            noValidate
            component="form"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              m: 'auto',
              width: 'fit-content',
            }}
          >
            <img width={popupWidth} src={popupLogo} alt="delete" />
          </Box>
          To confirm action, type property name <strong style={{ color: '#FF2929' }}>{propertyName}</strong>
          <FormControl fullWidth>
            <TextField
              variant="outlined"
              size="small"
              defaultValue={confirmAction}
              onChange={handleConfirmAction}
              helperText={confirmActionError}
              error={Boolean(confirmActionError)}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          {askPopup?(
            <>
              {askDeletePopup?(
                <Button onClick={() => handleDelete()}>
                  Yes
                </Button>
              ):(
                <Button onClick={() => handleUpdate()}>
                  Yes
                </Button>
              )}
              <Button onClick={handleClose} autoFocus>
                Close
              </Button>
            </>
          ):(
            <></>
          )}
        </DialogActions>
      </Dialog>
      
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 600 } }}
        open={addUserPopup}
        >
        <DialogContent dividers>
          <Typography gutterBottom variant="" component="div" sx={{ paddingY:2, fontSize: 20, fontWeight: 'bold'}}>
            User Permission
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={7} md={7} xl={7}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-select-small-label">Add People</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  label="addPeople"
                  value={addUserEmail}
                  onChange={(event) => [setAddUserEmail(event.target.value),setAddUserEmailError("")]}
                  error={Boolean(addUserEmailError)}
                >
                  {sortedUserInfo.map(item => (
                    !userPermissiom.find((items) => (items.user_email === item.email)) &&
                      <MenuItem value={item.email}>{item.email}</MenuItem> 
                  ))}
                </Select>
                <FormHelperText sx={{ color: '#EB4C49' }}>{addUserEmailError}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={3} md={3} xl={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-select-small-label">Access</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  label="Access"
                  value={addUserAccess}
                  onChange={(event) => setAddUserAccess(event.target.value)}
                >
                  <MenuItem value="viewer">Viewer</MenuItem>
                  <MenuItem value="editor">Editor</MenuItem>
                  <MenuItem value="network">Network Access</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={2} md={2} xl={2}>
              <FormControl fullWidth>
                <Button
                  onClick={() => handleUserAddToNetwork()}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                    }
                  }}
                >
                  <Icon height={25} color="#EEEDED" icon="mingcute:add-fill" />
                </Button>
              </FormControl>
            </Grid>
          </Grid>
          {userPermissiom.length > 0 && (
            <Typography gutterBottom variant="" component="div" sx={{ paddingY:2, fontSize: 16, fontWeight: 'bold'}}>
              People with access
            </Typography>
          )}
          
          {loading && (
            <>
              <Skeleton animation="wave" height={60} width="100%" />
              <Skeleton animation="wave" height={60} width="100%" />
            </>
          )}
          {userPermissiom.map((item, index) => (
            <div style={{marginBottom:"2%"}} key={index}>
              <Grid item container sx={{
                  bgcolor: "#F5F5F5",
                  borderRadius: '5px'
                }}>
                <Grid xs={12} sm={12} md={8} xl={8}>
                  <div style={{marginLeft :2}}>
                    <img width={20} src="../../user/user_email.png" alt="verified" style={{marginLeft :4, display: 'inline-block', verticalAlign: 'middle' }} />
                    <Typography gutterBottom variant="" component="div" sx={{ paddingTop:1, marginLeft :1, fontSize: 16, fontWeight: 'bold', display: 'inline-block', verticalAlign: 'middle' }}>
                        {item.user_email}
                    </Typography>
                  </div>
                </Grid>
                <Grid xs={12} sm={12} md={4} xl={4}>
                  <FormControl fullWidth size="small">
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={item.permission}
                      sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      onChange={(event) => handleUpdateUserPermission(event, index)}
                    >
                      <MenuItem value="viewer">Viewer</MenuItem>
                      <MenuItem value="editor">Editor</MenuItem>
                      <MenuItem value="network">Network Access</MenuItem>
                      <MenuItem value="remove">Remove Access</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button onClick={() => handleUpdateUserPermissionToNw()}>Done</Button>
        </DialogActions>
      </Dialog>

      <Grid item xs={12}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box to="/cloud/properties" component={RouterLink}>
            <img width={40} src="../../assets/back-button.gif" alt="verified" style={{ marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
          </Box>
          <Typography
            gutterBottom
            variant=""
            component="div"
            sx={{
              color: '#A8A196',
              textAlign: 'left',
              marginLeft: 2,
              paddingBottom: 1,
              fontSize: '1.5rem',
              fontWeight: 'bold',
            }}
          >
            {property.property.name}
            <Typography variant="" component="div" sx={{ fontSize: 16, color: '#4D4D4D' }}>
              {property.property.location}
            </Typography>
          </Typography>
        </div>
      </Grid>

      <Grid container xs={12} sm={12} md={2} xl={2}>
        <Box 
          sx={{
            position: "relative",
            ml:2,
            mb:2,
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={thumbnailPreview}
            onError={(e) => { e.target.src = "../assets/app/digivalet_placeholder.png"; }}
            alt="Thumbnail Preview"
            sx={{
              width: "100%",
              height: 120,
              objectFit: "cover",
              borderRadius: 1,
            }}
          />
          <Button
            component="label"
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              color: "#fff",
            }}
          >
            Thumbnail
            <input
              type="file"
              accept=".png, .jpeg, .jpg"
              hidden
              onChange={handleThumbnailChange}
            />
          </Button>
        </Box>
      </Grid>

      <Grid container xs={12} sm={12} md={10} xl={10} spacing={2}>
        <Grid item xs={12} sm={6} md={6} xl={6}>
          <FormControl sx={{ mx: 2 }} fullWidth size="small">
            <TextField
              label="Name"
              variant="outlined"
              size="small"
              defaultValue={propertyName}
              onChange={handlePropertyName}
              helperText={propertyNameError}
              error={Boolean(propertyNameError)}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6} xl={6}>
          <FormControl sx={{ mx:2 }} fullWidth size="small">
            <TextField
              label="Location"
              variant="outlined"
              size="small"
              defaultValue={location}
              onChange={handleLocation}
              helperText={locationError}
              error={Boolean(locationError)}
              inputProps={{ maxLength: 30 }}
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} md={6} xl={6}>
          <FormControl sx={{ mx:2 }} fullWidth size="small">
            <TextField
              label="API Key"
              variant="outlined"
              size="small"
              defaultValue={apikey}
              type="password"
              disabled={!editMode}
              onChange={(event) => {
                handleNetworks(event);
                handleAPIKey(event);
              }}
              helperText={Boolean(apiKeyError)?apiKeyError:(editMode ? '' : 'Click the edit icon to modify the API key')}
              error={Boolean(apiKeyError)}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleEditClick}>
                      <Iconify icon='tabler:edit' />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </Grid>

        {networkList.length > 0 ? (
          <>
            <Grid item xs={8} sm={4} md={4.5} xl={5}>
              <FormControl sx={{ mx:2 }} fullWidth size="small">
                <InputLabel id="demo-select-small-label">Networks</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={selectedNetwork}
                  label="Networks"
                  onChange={(event) => setSelectedNetwork(event.target.value)}
                >
                  {networkList.map((item) =>
                    <MenuItem value={item.id} key={item.id}>{item.name}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4} sm={2} md={1.5} xl={1}>
              <FormControl sx={{ mx:2 }} fullWidth>
                <Button
                  onClick={() => handleAddToSelectedNetworkList(selectedNetwork)}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    ":hover": {
                        bgcolor: "#7D7463",
                        borderColor: '#7D7463',
                  }}}>
                  <Icon height={25} color="#EEEDED" icon="fluent:add-20-regular" />
                </Button>
              </FormControl>
            </Grid>
          </>
        ):(
          <Grid item xs={12} sm={6} md={6} xl={6} mt={-2}>
            <Skeleton animation="wave" sx={{ mx:2 }}  height={70} width="100%" />
          </Grid>
        )}
      </Grid>

      {selectedNetworkList.length > 0 && (
        <Grid item xs={12}>
          <Typography color="text.secondary" sx={{ mb: 2, fontSize: 14, fontWeight: 'bold' }}>
            CONFIGURE PROPERTY NETWORK
          </Typography>
        </Grid>
      )}

      {selectedNetworkList.map((item, index) =>
        <Container key={item.id} maxWidth="xxl" sx={{
          border: 1,
          borderRadius: '8px',
          marginLeft: '15px',
          marginBottom: '15px',
          borderColor: '#f2f0eb',
          borderLeft: 5,
          borderLeftColor: '#A8A196',
          borderRight: 5,
          borderRightColor: '#A8A196'
        }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Display Name"
                  variant="outlined"
                  size="small"
                  defaultValue={item.displayName}
                  onChange={(event) => handleDisplayName(event, index)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Application identifier"
                  variant="outlined"
                  size="small"
                  defaultValue={item.appIdentifier}
                  onChange={(event) => handleAppIdentifier(event, index)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Application ID"
                  variant="outlined"
                  size="small"
                  defaultValue={item.appId}
                  onChange={(event) => handleApplicationID(event, index)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <InputLabel id="demo-select-small-label">SAM Tag</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="SAMTag"
                  value={item.tag_dv}
                  onChange={(event) => handleSAMTag(event, index)}
                >
                  {item.tags.map(items =>
                    <MenuItem value={items} key={index}>{items}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <InputLabel id="demo-select-small-label">Maintenance SAM Tag</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  label="MaintenanceSAMTag"
                  value={item.tag_maintenance}
                  onChange={(event) => handleMaintenanceTag(event, index)}
                >
                  {item.tags.map(items =>
                    <MenuItem value={items} key={index}>{items}</MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Network name"
                  variant="outlined"
                  size="small"
                  disabled
                  id="outlined-disabled"
                  defaultValue={item.name}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4} xl={2.4}>
              <FormControl sx={{ my: 1 }} fullWidth size="small">
                <TextField
                  label="Meraki Network ID"
                  variant="outlined"
                  size="small"
                  disabled
                  id="outlined-disabled"
                  defaultValue={item.id}
                />
              </FormControl>
            </Grid>

            <Grid item xs={8.8} sm={4} md={4} xl={4.2}>
              <div style={{ display: 'flex',  justifyContent:"center" }}>
                <Avatar 
                  src={item.icon? item.icon: appLogo}
                  sx={{ borderRadius: '10%' , marginRight:'10px', my: 1}}
                />
                <FormControl sx={{ my: 1 }} fullWidth  size="small">
                  <TextField
                    label="Application Version"
                    variant="outlined"
                    size="small"
                    value={item.version ? `${item.version} (${item.build_version})` : "Sync App Version"}
                    disabled
                    helperText="Please Sync the app version on Meraki Dashboard before syncing here"
                    />
                </FormControl>
              </div>
            </Grid>
            <Grid item xs={3.2} sm={2} md={1.4} xl={1}>
              <FormControl fullWidth sx={{ my: 1 }}>
                <Button
                  onClick={() => handleSyncAppVersion(item.id, item.appIdentifier, item.tag_dv, item.tag_maintenance, item.appId, index)}
                  disabled={buttonDisabled[index]}
                  sx={{
                    color: buttonDisabled[index] ? "#A8A196" : "#FFF",
                    border: 1,
                    borderColor: '#A8A196',
                    bgcolor: '#A8A196',
                    ":hover": {
                        bgcolor: "#7D7463",
                        borderColor: '#7D7463',
                    }}}>
                    {buttonDisabled[index] && (<CircularProgress
                        size={24}
                        sx={{
                          color:'#FFF',
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          marginTop: '-12px',
                          marginLeft: '-12px',
                        }}
                  />)}
                  Sync
                </Button>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={1.3} xl={1}>
              <FormControl sx={{ my: 1 }} fullWidth>
                <Button
                  disabled
                  onClick={() => handleAddUserPopup(item)}
                  sx={{
                    color: '#FFF',
                    // border: 1,
                    // borderColor: '#A8A196',
                    bgcolor: '#EEEEEE',
                    ":hover": {
                        bgcolor: "#7D7463",
                        borderColor: '#7D7463',
                    }
                  }}>
                  <Icon height={25} color="#BCCCDC" icon="wpf:add-user" />
                </Button>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={1.3} xl={1}>
              <FormControl sx={{ my: 1 }} fullWidth>
                <Button
                  onClick={() => handleAddToNetworkList(item.id)}
                  sx={{
                    color: '#FFF',
                    border: 1,
                    borderColor: '#E74646',
                    bgcolor: '#E74646',
                    ":hover": {
                        bgcolor: "#BB2525",
                        borderColor: '#BB2525',
                    }
                  }}>
                  <Icon height={25} color="#EEEDED" icon="fluent:delete-20-regular" />
                </Button>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      )}

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Created By Name"
          value={property.property.created_by_name}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Modified By Name"
          value={property.property.modified_by_name}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Created By Email"
          value={property.property.created_by_email}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Modified By Email"
          value={property.property.modified_by_email}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Created On Date"
          value={formatDate(property.property.created_on)}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={6} xl={6}>
        <TextField
          fullWidth
          disabled
          id="standard-disabled"
          label="Modified On Date"
          value={formatDate(property.property.modified_on)}
          variant="outlined"
          size="small"
          sx={{ my: 1 }}
        />
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
          }}
        >
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
            <Button
              onClick={handleCancel}
              sx={{
                color: '#9BA4B5',
                border: 1,
                borderColor: '#B5C0D0',
                bgcolor: '#FFF',
                ":hover": {
                    bgcolor: "#EEEEEE",
                    borderColor: '#EEEEEE',
                }
              }}
              >
              Back
            </Button>
          </FormControl>
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.5%', xl:'16.5%' }}}>
            <Button
              onClick={() => handleDeletePopupAsk()}
                sx={{
                  color: '#FFF',
                  border: 1,
                  borderColor: '#E74646',
                  bgcolor: '#E74646',
                  marginRight:2,
                  ":hover": {
                      bgcolor: "#BB2525",
                      borderColor: '#BB2525',
                  }
                }}>
              DELETE
            </Button>
          </FormControl>
          <FormControl sx={{width: { xs: '100%', sm: '100%', md:'16.4%', xl:'16.4%' }}}>
            <Button
              onClick={() => handlePopupAsk()}
                sx={{
                  color: '#FFF',
                  border: 1,
                  borderColor: '#A8A196',
                  bgcolor: '#A8A196',
                  marginRight:2,
                  ":hover": {
                      bgcolor: "#7D7463",
                      borderColor: '#7D7463',
                  }
                }}>
              UPDATE
            </Button>
          </FormControl>
        </Box>
      </Grid>
    </>
  );
}